// extracted by mini-css-extract-plugin
export var container = "youtube-video-module--container--1vALs";
export var video = "youtube-video-module--video--6JbFK";